import { Model, RailsFormat } from "./model";
import { Utilities } from "@helpers/utilities";
import { Contact } from "./contact";
import { TransactionCycleMetadata } from "./transaction-cycle-metadata";

export class Transaction extends Model {

  constructor(
    public id?: number,
    public studentId?: number,
    public debtorId?: number,
    public enrolmentId?: number,
    public discountId?: number,
    public parentId?: number,
    public description: string = null,
    public amount: number = 0,
    public transactionType: number = 0,
    public paymentType: number = null,
    public transactionDate: Date = null,
    public paymentReference: string = null,
    public status: number = 0,
    public statusMessage: string = null,
    public processedAt: Date = null,

    public parent: Transaction = null,
    public debtor: Contact = null,

    public cycleMetadata: TransactionCycleMetadata = null,

    public isMenuOpen: boolean = false,
    public isChecked: boolean = false,

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super() }

  static clone(obj: any) {
    const t = new this()

    if (obj.id) { t.id = obj.id }
    if (obj.studentId) { t.studentId = obj.studentId }
    if (obj.debtorId) { t.debtorId = obj.debtorId }
    if (obj.enrolmentId) { t.enrolmentId = obj.enrolmentId }
    if (obj.discountId) { t.discountId = obj.discountId }
    if (obj.parentId) { t.parentId = obj.parentId }
    if (obj.description) { t.description = obj.description }
    if (obj.amount) { t.amount = parseFloat(obj.amount) }
    if (obj.transactionType) { t.transactionType = obj.transactionType }
    if (obj.paymentType) { t.paymentType = obj.paymentType }
    if (obj.transactionDate) { t.transactionDate = Utilities.makeDate(obj.transactionDate) }
    if (obj.paymentReference) { t.paymentReference = obj.paymentReference }
    if (obj.status) { t.status = obj.status }
    if (obj.statusMessage) { t.statusMessage = obj.statusMessage }
    if (obj.processedAt) { t.processedAt = new Date(obj.processedAt) }

    if (obj.parent) { t.parent = Transaction.clone(obj.parent) }
    if (obj.debtor) { t.debtor = Contact.clone(obj.debtor) }
    if (obj.cycleMetadata) { t.cycleMetadata = TransactionCycleMetadata.clone(obj.cycleMetadata) }

    if (obj.createdAt) { t.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { t.updatedAt = new Date(obj.updatedAt) }

    return t
  }

  serializeForRails(): any {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }

    return response
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/transaction.ts